import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard.vue?vue&type=script&lang=js
// module id = HKwo
// module chunks = 7